import { useState, useRef } from 'react';
import { useForm } from "react-hook-form";

import { ReactComponent as Cancel } from '../assets/cancel.svg';

import { Editor } from './Editor';

export default function Avatars ({value, saveAvatars, hideAvatars}) {

	console.log(value);

    const avatars_default = {
		
		avatars_bucket: {
			hint: "Url to the bucket where your avatars are hosted",
			value: {
				default: 'https://r2.lagoon.live/'
			}
		},
		avatars_total: {
			hint: "Total number of unique avatars",
			value: {
				default: 3000
			}
		},
		avatars_prefix: {
			hint: "Avatars prefix (what goes before -<index>.EXT)",
			value: {
				default: 'fortinet-',
			}
		},
		avatars_ext: {
			hint: "Image file extension (e.g. 'jpg')",
			value: {
				default: 'jpg'
			}
		}
    };

    var avatars = avatars_default;

	console.log(value);

	if (value) {

		for (let key in avatars_default){
			if(value[key]['value'])
				avatars[key]['value'] = value[key]['value'];
		}
    }

    const {
		register,
		reset,
		setValue,
		handleSubmit,
		formState: { errors },
    } = useForm();

    const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

    const saveButton = (data) => {

	console.log(data);
        saveAvatars (data['avatars']);
        hideAvatars ();
    }

    const changeEditor = (data) => {
    }

    return (

		<div className="right right_logo texts">
			<div className="dashed-border">
				<div className="title">
					<div>
						<div className="name">Avatars</div>
					</div>
					<div>
						<div className="cancel" onClick={hideAvatars}>
						<Cancel/>
						</div>
					</div>
				</div>

				<form className="">

					{!!avatars &&

						Object.keys(avatars).map( (key, index) =>

							<div key={index}>

								<div className="subtitle">
									{avatars[key].hint}
								</div>

								<textarea
									{...register("avatars["+key+"].value.value")}
									placeholder={avatars[key].value.default}
									defaultValue={avatars[key].value.value ? avatars[key].value.value : avatars[key].value.default}
								>
								</textarea>

							</div>
						)
					}

					<button type="submit" className="button check save" onClick={handleSubmit(saveButton)}>
						Save
					</button>

					<div className="error">{ message }</div>

				</form>

			</div>

	    </div>

    )

}
